<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card class="bg-grey-lighten-2 mb-15">
          <v-form @submit.prevent="formSubmit" ref="form">
            <!-- step one -->
            <div v-show="currentStep == 0">
              <v-col>
                <v-card class="mb-5">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-select
                          id="purposeofenq"
                          v-model="purposeOfEnq"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsPurposeOfEnq"
                          :rules="purposeOfEnqRules"
                        >
                          <template #label>
                            Purpose of Enquiry
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          id="idmessage"
                          v-model="idMessage"
                          :rules="idMessageRules"
                        >
                          <template #label>
                            Message ID/ Reference Number
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle class="font-weight-bold pa-5">
                    Company Details
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          id="tradeName"
                          v-model="tradeName"
                          :rules="tradeNameRules"
                        >
                          <template #label>
                            Company Trade Name
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="companycCategory"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsCompanyCategory"
                          label="Company Category"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="legalForm"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsLegalForm"
                          label="Legal Form"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-select
                          id="goPublic"
                          v-model="goPublic"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsGoPublic"
                          label="Go Public"
                        >
                        </v-select>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          id="rating"
                          type="text"
                          v-model="rating"
                          label="Rating"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="ratingIntitution"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsratingIntitution"
                          label="Rating Intitution"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          id="ratingDate"
                          type="date"
                          v-model="ratingDate"
                          label="Rating Date"
                        >
                        </v-text-field>
                        <!-- <v-select
                          v-model="resident"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsResident"
                          label="Resident"
                        ></v-select> -->
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          v-model="economicSector"
                          :items="itemsEconomicSector"
                          item-text="titleSelect"
                          item-value="valSelect"
                          label="Economic Selector"
                        >
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <!-- <v-select
                          v-model="educationalStatusCode"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :items="itemsEducationalStatusCode"
                          label="Education Status"
                        ></v-select> -->
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-5">
                  <v-card-subtitle class="font-weight-bold pa-5">
                    Company Establishment
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="placeOfEstablishment"
                          label="Place Of Establishment"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="deedNumberOfEstablishment"
                          label="Deed Number of Establishment"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="deedDateOfEstablishment"
                          type="date"
                          label="Deed Date of Establishment"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="recentlyAmendmentDeedNumber"
                          label="Recently Amendment Deed Number"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="dateOfFinalAmendmentDeed"
                          type="date"
                          label="Date of Final Amendment Deed"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <!-- <v-select
                          v-model="country"
                          :items="itemsCountry"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="countryRules"
                        >
                          <template #label>
                            Country
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select> -->
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-5">
                  <v-card-subtitle class="font-weight-bold pa-5">
                    Address Data
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field v-model="address" :rules="addressRules">
                          <template #label>
                            Address
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="subDistrict"
                          :rules="subDistrictRules"
                        >
                          <template #label>
                            Sub District
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="district"
                          :rules="districtRules"
                          label="District"
                        >
                          <template #label>
                            District
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          v-model="city"
                          :items="itemsCity"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="cityRules"
                        >
                          <template #label>
                            City
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="postalCode"
                          :rules="postalCodeRules"
                        >
                          <template #label>
                            Postal Code
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="country"
                          :items="itemsCountry"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="countryRules"
                        >
                          <template #label>
                            Country
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-5">
                  <v-card-subtitle class="font-weight-bold pa-5">
                    Identification Documents
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="businessIdentityNumber"
                          :rules="businessIdentityNumberRules"
                        >
                          <template #label>
                            Business Identity Number
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-5">
                  <v-card-subtitle class="font-weight-bold pa-5">
                    Contact Data
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="phoneNumber"
                          label="Phone Number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="cellphoneNumber"
                          :rules="cellphoneNumberRules"
                        >
                          <template #label>
                            Cell Phone Number
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="email"
                          v-model="emailAddress"
                          label="Email Address"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  v-if="!progressBtnNext"
                  @click="nextPageForm"
                  color="primary"
                  class="mt-2"
                  >Next</v-btn
                >
                <v-progress-circular
                  v-if="progressBtnNext"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-card-actions>
            </div>
            <!-- step two -->
            <div v-show="currentStep == 1">
              <v-col cols="12" md="8">
                <v-radio-group
                  v-model="statusApp"
                  column
                  @change="selectStatusApp"
                >
                  <v-radio
                    color="indigo"
                    label="New Application Data"
                    value="A"
                  ></v-radio>
                  <v-radio
                    color="indigo"
                    label="Enquire the Subject witch a role in an enquired Application"
                    value="B"
                  ></v-radio>
                  <v-radio
                    color="indigo"
                    label="Enquire the Subject witch a role in an enquired Company"
                    value="C"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col>
                <v-card v-if="statusApp == 'A'" class="mb-5">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="roleInApplication"
                          :items="itemsRoleInApplication"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="roleInApplicationRules"
                          @change="onSelectContractCategory(roleInApplication)"
                        >
                          <template #label>
                            Role In Application
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="contractCategoryCode"
                          :items="itemsContractCategoryCode"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="contractCategoryRules"
                          @change="onSelectContractType(contractCategoryCode)"
                        >
                          <template #label>
                            Contract Category
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="contractType"
                          :items="itemsContractType"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="contractTypeRules"
                        >
                          <template #label>
                            Contract Type
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card v-if="statusApp == 'A'">
                  <v-card-subtitle class="font-weight-bold pa-5">
                    Subject Details
                  </v-card-subtitle>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="accountNumber"
                          label="Account Number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="date"
                          v-model="dueDate"
                          label="Due Date"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="applicationAmount"
                          :rules="applicationAmountRules"
                        >
                          <template #label>
                            Application Amount
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="text"
                          v-model="currencyReadOnly"
                          readonly
                          placeholder="Indonesia Rupiah"
                        >
                          <template #label>
                            Currency
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="originalAgreementNumber"
                          label="Original Agreement Number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="date"
                          v-model="originalAgreementDate"
                          label="Original Agreement Date"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card v-if="statusApp !== 'A'">
                  <v-card-subtitle class="font-weight-bold pa-5">
                    {{
                      statusApp == "B"
                        ? "Role in the Application"
                        : "Role in the Company"
                    }}
                  </v-card-subtitle>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-select
                          v-model="roleInApplication"
                          :items="itemsRoleInApplication"
                          item-text="titleSelect"
                          item-value="valSelect"
                          :rules="roleInApplicationRules"
                        >
                          <template #label>
                            Role In Application
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="text"
                          v-model="cbContractCode"
                          :rules="cbContractCodeRules"
                        >
                          <template #label>
                            CB Contract Code
                            <span class="text-red ml-1"
                              ><strong> *</strong></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="providerContractNo"
                          label="Provider Contract Number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          type="number"
                          v-model="providerApplicationNo"
                          :rules="providerApplicationNoRules"
                          label="Provider Application Number"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-card-actions>
                <v-btn @click="backPageForm" color="grey" class="mt-2"
                  >Back</v-btn
                >
                <v-spacer />
                <v-btn type="submit" color="primary" class="mt-2">Submit</v-btn>
              </v-card-actions>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- content results data -->
    <v-row
      justify="center"
      v-if="resultsDataXml !== null && !resultsDataXml.error"
    >
      <v-dialog
        v-model="dialog"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeModalBox">
              <v-icon> mdi-close </v-icon>
            </v-btn>
            <v-toolbar-title>Detail</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <!-- Jika tidak match -->
          <v-col
            class="pb-10"
            v-if="
              resultsDataXml !== null
                ? resultsDataXml.matchedSubData.FlagMatched == '0'
                : false
            "
          >
            <v-row>
              <v-col>
                <span
                  >Request Date:
                  {{
                    resultsDataXml !== null
                      ? resultsDataXml.matchedSubData.LastUpdateDate
                      : ""
                  }}</span
                >
                <span
                  class="rounded-lg font-weight-bold white--text py-1 px-2 green darken-1 ml-5"
                >
                  {{
                    resultsDataXml !== null
                      ? resultsDataXml.matchedSubData.FlagMatched == "0"
                        ? "Subject No Matched"
                        : "Subject Matched"
                      : ""
                  }}
                </span>
                <span
                  v-if="
                    resultsDataXml !== null &&
                    resultsDataXml.scoreDataData.Description
                  "
                  class="rounded-lg font-weight-bold white--text py-1 px-2 yellow darken-1 ml-5"
                >
                  {{
                    resultsDataXml !== null
                      ? resultsDataXml.scoreDataData.Description
                      : ""
                  }}
                </span>
              </v-col>
            </v-row>
            <v-card-title class="pa-5 text-h5 d-block text-center">
              SUBJECT
            </v-card-title>
            <v-card class="mb-3">
              <v-card-subtitle class="mb-3 text-h6">
                Subject Data
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> CB Subject Code </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.CBSubjectCode
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Provider Subject Code </v-card-subtitle>
                    <v-card-text>
                      <!-- {{ resultsDataXml.provider_application_no }} -->
                      -
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.LastUpdateDate
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Go Public </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.GoPublicDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Trade Name </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.TradeName
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Company Category </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.CompanyCategory
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Legal Form </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.LegalFormDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Economic Sector </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.EconomicSectorDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Rating </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.Rating
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Rating Institution </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.RatingInstitutionDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Rating Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.RatingDate
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Shareholders Counte </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.ShareholdersCounter
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-3">
              <v-card-subtitle class="mb-3 text-h6">
                Establishment Data
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Place Of Establishment </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.PlaceOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Deed Number of Establishment
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.DeedNumberOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Deed Date of Establishment
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.DeedDateOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Recently Amendment Deed Number
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.RecentlyeOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Date of Final Amendment Deed
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData
                              .DateofFinalAmendmentDeedNumber
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-card-subtitle class="mb-3 text-h6">
                      Identification Code
                    </v-card-subtitle>
                    <v-divider :thickness="3" class="blue"></v-divider>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <v-card-subtitle> Identity Number </v-card-subtitle>
                          <v-card-text>
                            {{
                              resultsDataXml !== null
                                ? resultsDataXml.enqData.BusinessIdentityNumber
                                : "-"
                            }}
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6"> Contacts </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-card-subtitle> Current - Contact </v-card-subtitle>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Phone Number </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.PhoneNumber
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Cell Phone Number </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.CellphoneNumber
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Email Address </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.enqData.EmailAddress
                            ? resultsDataXml.enqData.EmailAddress
                            : "-"
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text> - </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end jika tidak match -->

          <!-- jika match -->
          <v-col
            class="pb-10"
            v-if="
              resultsDataXml !== null
                ? resultsDataXml.matchedSubData.FlagMatched !== '0'
                : false
            "
          >
            <v-row justify="space-between">
              <v-col cols="12" md="2">
                <span
                  >Request Date:
                  {{
                    resultsDataXml != null
                      ? resultsDataXml.matchedSubData.LastUpdateDate
                      : ""
                  }}</span
                >
              </v-col>
              <v-col cols="12" md="8">
                <span
                  class="rounded-lg font-weight-bold white--text py-1 px-2 green darken-1"
                >
                  {{
                    resultsDataXml !== null
                      ? resultsDataXml.matchedSubData.FlagMatched == "0"
                        ? "Subject No Matched"
                        : "Subject Matched"
                      : ""
                  }}
                </span>
                <span
                  v-if="
                    resultsDataXml !== null &&
                    resultsDataXml.scoreDataData.Description
                  "
                  class="rounded-lg font-weight-bold white--text py-1 px-2 yellow darken-1 ml-5"
                >
                  {{
                    resultsDataXml !== null
                      ? resultsDataXml.scoreDataData.Description
                      : ""
                  }}
                </span>
              </v-col>
              <v-col cols="12" md="2">
                <export-pdf-click-vue
                  :dataForExport="
                    resultsDataXml != null ? resultsDataXml : null
                  "
                ></export-pdf-click-vue>
              </v-col>
            </v-row>
            <v-card-title class="pa-5 text-h5 d-block text-center">
              SUBJECT
            </v-card-title>
            <v-card class="mb-3">
              <v-card-subtitle class="mb-3 text-h6">
                Subject Data
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> CB Subject Code </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.CBSubjectCode
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Provider Subject Code </v-card-subtitle>
                    <v-card-text>
                      <!-- {{ resultsDataXml.provider_application_no }} -->
                      -
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.LastUpdateDate
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Go Public </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.GoPublicDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Trade Name </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.TradeName
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Company Category </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.CompanyCategory
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Legal Form </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.LegalFormDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Economic Sector </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.EconomicSectorDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Rating </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.Rating
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Rating Institution </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.RatingInstitutionDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Rating Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.RatingDate
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Shareholders Counte </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.ShareholdersCounter
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-3">
              <v-card-subtitle class="mb-3 text-h6">
                Establishment Data
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Place Of Establishment </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.PlaceOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Deed Number of Establishment
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData
                              .DeedNumberOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Deed Date of Establishment
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData
                              .DeedDateOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Recently Amendment Deed Number
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData
                              .RecentlyeOfEstablishment
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Date of Final Amendment Deed
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData
                              .DateofFinalAmendmentDeedNumber
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                Addresses Data
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="8">
                    <v-card-subtitle> Current - Address </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .Address
                          : ""
                      }},
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .SubDistrict
                          : ""
                      }},
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .District
                          : ""
                      }},
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .CityDesc
                          : ""
                      }},
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .PostalCode
                          : ""
                      }},
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .CountryDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.AddressHistory[0]
                              .lastUpdateDate
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-divider
                  v-if="
                    resultsDataXml !== null &&
                    resultsDataXml.matchedSubData.AddressHistory.length > 1
                  "
                  :thickness="3"
                ></v-divider>
                <v-row
                  v-for="(item, index) in resultsDataXml !== null
                    ? resultsDataXml.matchedSubData.AddressHistory
                    : []"
                  :key="index"
                  :class="{ 'd-none': index == 0 }"
                >
                  <v-col cols="12" sm="8">
                    <v-card-subtitle> Historical - Address </v-card-subtitle>
                    <v-card-text>
                      <template v-if="index !== 0">
                        {{ item.Address }}, {{ item.SubDistrict }},
                        {{ item.District }}, {{ item.CityDesc }},
                        {{ item.PostalCode }}, {{ item.CountryDesc }}
                      </template>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text>
                      <template v-if="index !== 0">
                        {{ item.lastUpdateDate }}
                      </template>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-card-subtitle class="mb-3 text-h6">
                      Identification Code
                    </v-card-subtitle>
                    <v-divider :thickness="3" class="blue"></v-divider>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <v-card-subtitle> Identity Number </v-card-subtitle>
                          <v-card-text>
                            {{
                              resultsDataXml !== null
                                ? resultsDataXml.matchedSubData
                                    .BusinessIdentityNumber
                                : "-"
                            }}
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6"> Contacts </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-card-subtitle> Current - Contact </v-card-subtitle>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Phone Number </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.ContactHistory[0]
                              .PhoneNumber
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Cell Phone Number </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.ContactHistory[0]
                              .CellphoneNumber
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Email Address </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.ContactHistory[0]
                              .EmailAddress
                            ? resultsDataXml.matchedSubData.ContactHistory[0]
                                .EmailAddress
                            : "-"
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.matchedSubData.ContactHistory[0]
                              .lastUpdateDate
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-divider
                  v-if="
                    resultsDataXml !== null &&
                    resultsDataXml.matchedSubData.ContactHistory.length > 1
                  "
                  :thickness="3"
                ></v-divider>
                <v-card-subtitle
                  class="mt-3"
                  v-if="
                    resultsDataXml !== null &&
                    resultsDataXml.matchedSubData.ContactHistory.length > 1
                  "
                >
                  Historical - Contact
                </v-card-subtitle>
                <v-row
                  v-for="(item, index) in resultsDataXml !== null
                    ? resultsDataXml.matchedSubData.ContactHistory
                    : []"
                  :key="index"
                  :class="{ 'd-none': index == 0 }"
                >
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Phone Number </v-card-subtitle>
                    <v-card-text>
                      <template v-if="index !== 0">
                        {{ item.PhoneNumber ? item.PhoneNumber : "-" }}
                      </template>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Cell Phone Number </v-card-subtitle>
                    <v-card-text>
                      <template v-if="index !== 0">
                        {{ item.CellphoneNumber ? item.CellphoneNumber : "-" }}
                      </template>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Email Address </v-card-subtitle>
                    <v-card-text>
                      <template v-if="index !== 0">
                        {{ item.EmailAddress ? item.EmailAddress : "-" }}
                      </template>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Last Update Date </v-card-subtitle>
                    <v-card-text>
                      <template v-if="index !== 0">
                        {{ item.lastUpdateDate }}
                      </template>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              APPLICATION SUMMARY DETAILS
            </v-card-title>
            <v-card class="mb-6">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> CB Contact Code </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.appCodeData.CBContractCode
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Contract Type </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.appCodeData.ContractTypeDesc
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Contract Phase </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.appCodeData.ContractPhaseDesc
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Request Date </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? new Date(
                              resultsDataXml.appCodeData.ContractRequestDate.substring(
                                0,
                                4
                              ) +
                                "-" +
                                resultsDataXml.appCodeData.ContractRequestDate.substring(
                                  4,
                                  6
                                ) +
                                "-" +
                                resultsDataXml.appCodeData.ContractRequestDate.substring(
                                  6,
                                  8
                                )
                            )
                              .toISOString()
                              .split("T")[0]
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Application Amount </v-card-subtitle>
                    <v-card-text>
                      IDR
                      {{
                        resultsDataXml !== null
                          ? toRupiah(
                              resultsDataXml.appCodeData.ApplicationAmount
                            )
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Due Date </v-card-subtitle>
                    <v-card-text>
                      <!-- {{ resultsDataXml !== null ? resultsDataXml.appCodeData.DueDate : '-' }} -->
                      -
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Role </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.appCodeData.RoleDesc
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Company Role </v-card-subtitle>
                    <v-card-text>
                      <!-- {{ resultsDataXml !== null ? resultsDataXml.appCodeData.CompanyRole : '-' }} -->
                      -
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Account Number </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.appCodeData.ProviderApplicationNo
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Original Agreement Number
                    </v-card-subtitle>
                    <v-card-text>
                      <!-- {{ resultsDataXml !== null ? resultsDataXml.appCodeData.OriginalAgreementNumber : '-' }} -->
                      -
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Original Agreement Date </v-card-subtitle>
                    <v-card-text>
                      <!-- {{ resultsDataXml !== null ? resultsDataXml.appCodeData.OriginalAgreementDate : '-' }} -->
                      -
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Currency </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.appCodeData.CurrencyDesc
                          : "-"
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              SHAREHOLDER
            </v-card-title>
            <v-card class="mb-6">
              <v-expansion-panels v-model="panelShareHolderDetails" multiple>
                <v-expansion-panel
                  v-for="(item, index) in resultsDataXml !== null
                    ? resultsDataXml.matchedSubData.ShareholdersData
                    : []"
                  :key="index"
                >
                  <v-expansion-panel-header>
                    ShareHolder Data {{ index }}: {{ item.NameOfShareholder }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card class="mb-6">
                      <v-card-subtitle class="mb-3 text-h6">
                        ShareHolder Data {{ index }}:
                        {{ item.NameOfShareholder }}
                      </v-card-subtitle>
                      <v-divider :thickness="3" class="blue"></v-divider>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="3">
                            <v-card-subtitle> Gender </v-card-subtitle>
                            <v-card-text>
                              {{ item.GenderDesc }}
                            </v-card-text>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-card-subtitle>
                              Share Of Ownership
                            </v-card-subtitle>
                            <v-card-text> {{ item.NoOfShares }} % </v-card-text>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-card-subtitle> Position </v-card-subtitle>
                            <v-card-text>
                              {{ item.Position }}
                            </v-card-text>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-card-subtitle> Mandate Status </v-card-subtitle>
                            <v-card-text>
                              {{ item.ManagerStatusDesc }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-subtitle class="mb-3 text-h6">
                        Identification Code
                      </v-card-subtitle>
                      <v-divider :thickness="3" class="blue"></v-divider>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="3">
                            <v-card-subtitle> Identity Type </v-card-subtitle>
                            <v-card-text>
                              {{ item.IdentityTypeDesc }}
                            </v-card-text>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-card-subtitle> Identity Number </v-card-subtitle>
                            <v-card-text>
                              {{ item.IdentityNumber }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-subtitle class="mb-3 text-h6">
                        Address
                      </v-card-subtitle>
                      <v-divider :thickness="3" class="blue"></v-divider>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-card-subtitle> Address </v-card-subtitle>
                            <v-card-text>
                              {{ item.Address }}{{ item.SubDistrict
                              }}{{ item.District }}{{ item.CityDesc }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              SCORE DETAIL
            </v-card-title>
            <v-card class="mb-6">
              <v-card-text
                v-if="resultsDataXml.scoreDataData.ScoreData.Code !== ''"
              >
                <v-row>
                  <v-col>
                    <p>Score Raw</p>
                    <p>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.scoreDataData.ScoreData.ScoreRaw
                          : ""
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <p>Score Range</p>
                    <p>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.scoreDataData.ScoreData.ScoreRange
                          : ""
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <p>Description</p>
                    <p>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.scoreDataData.ScoreData.Description
                          : ""
                      }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-text
                v-if="
                  resultsDataXml.scoreDataData.ExclusionRule
                    .CodeExclusionRule !== ''
                "
              >
                <v-row>
                  <v-col>
                    <p>Description</p>
                    <p>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.scoreDataData.ExclusionRule
                              .DescriptionExclusionRule
                          : ""
                      }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              CONTRACTS SUMMARY
            </v-card-title>
            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                Key Values
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Contracts number </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.ContractsNumber
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Reporting Providers Number
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData
                              .ReportingProvidersNumber
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Total Credit Limit </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.Currency
                          : ""
                      }}
                      {{
                        resultsDataXml !== null
                          ? toRupiah(
                              resultsDataXml.contractsHistoryData
                                .TotalCreditLimit
                            )
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle>
                      Total Potential Exposure
                    </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.Currency
                          : ""
                      }}
                      {{
                        resultsDataXml !== null
                          ? toRupiah(
                              resultsDataXml.contractsHistoryData
                                .TotalPotentialExposure
                            )
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Total Debit Balance </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.Currency
                          : ""
                      }}
                      {{
                        resultsDataXml !== null
                          ? toRupiah(
                              resultsDataXml.contractsHistoryData
                                .TotalDebitBalance
                            )
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Total Overdue </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.Currency
                          : ""
                      }}
                      {{
                        resultsDataXml !== null
                          ? toRupiah(
                              resultsDataXml.contractsHistoryData.TotalOverdue
                            )
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-card-subtitle> Currency </v-card-subtitle>
                    <v-card-text>
                      {{
                        resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.CurrencyDesc
                          : ""
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                Summary by Category and Phase
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Contract Category</th>
                        <th class="text-left">Requested</th>
                        <th class="text-left">Refused</th>
                        <th class="text-left">Renounced</th>
                        <th class="text-left">Active</th>
                        <th class="text-left">Close</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in resultsDataXml !== null
                          ? resultsDataXml.contractsHistoryData.ContractCategory
                          : []"
                        :key="index"
                      >
                        <td>{{ item.Name }}</td>
                        <td>{{ item.Requested }}</td>
                        <td>{{ item.Refused }}</td>
                        <td>{{ item.Renounced }}</td>
                        <td>{{ item.Active }}</td>
                        <td>{{ item.Closed }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                Financial Summary
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <div class="py-5 px-5">
                <v-row>
                  <v-col
                    v-for="(item, index) in resultsDataXml !== null
                      ? resultsDataXml.contractsHistoryData.ContractCategory
                      : []"
                    :key="index"
                    cols="12"
                    md="6"
                  >
                    <v-row>
                      <v-col>
                        <v-icon
                          v-if="item.Active > 0"
                          medium
                          color="green darken-2"
                        >
                          mdi-check-circle
                        </v-icon>
                        <v-icon
                          v-if="item.Active == 0"
                          medium
                          color="black darken-2"
                        >
                          mdi-close-circle
                        </v-icon>
                      </v-col>
                      <v-col cols="11">
                        <p>{{ item.Name }}</p>
                        <p>Active {{ item.Name }}: {{ item.Active }}</p>
                        <v-divider :thickness="3" class="mb-1"></v-divider>
                        <v-row v-if="item.CreditLimit !== ''">
                          <v-col>
                            <p>Cradit Limit</p>
                          </v-col>
                          <v-col>
                            <p>IDR</p>
                            <p>{{ toRupiah(item.CreditLimit) }}</p>
                          </v-col>
                        </v-row>
                        <v-row v-if="item.DebitBalance !== ''">
                          <v-col>
                            <p>Debit Balance</p>
                          </v-col>
                          <v-col>
                            <p>IDR</p>
                            <p>{{ toRupiah(item.DebitBalance) }}</p>
                          </v-col>
                        </v-row>
                        <v-row v-if="item.Overdue !== ''">
                          <v-col>
                            <p>Overdue</p>
                          </v-col>
                          <v-col>
                            <p>IDR</p>
                            <p>{{ toRupiah(item.Overdue) }}</p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              CONTRACTS DETAILS
            </v-card-title>
            <v-card class="mb-6">
              <v-expansion-panels v-model="panelContractDetails" multiple>
                <v-expansion-panel
                  v-for="(item, index) in resultsDataXml !== null
                    ? resultsDataXml.contractsHistoryData.ContractCategory
                    : []"
                  :key="index"
                >
                  <v-expansion-panel-header>
                    {{ item.Name }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card-subtitle>
                      {{ item.Name }} Detail (Requested, Renounced, and Refused)
                    </v-card-subtitle>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">No</th>
                            <th class="text-left">CB Contract Code</th>
                            <th class="text-left">Provider Contract Number</th>
                            <th class="text-left">Contract type</th>
                            <th class="text-left">Contract Phase</th>
                            <th class="text-left">Role</th>
                            <th class="text-left">Provider Type</th>
                            <th class="text-left">Provider</th>
                            <th class="text-left">Contract Request Date</th>
                            <th class="text-left">last Update Date</th>
                            <th class="text-left">Link Subject List</th>
                            <th class="text-left">Note</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(subItem, index) in item.NotGranted"
                          :key="index"
                        >
                          <tr>
                            <td>{{ index + 1 }}</td>
                            <td>{{ subItem.CBContractCode }}</td>
                            <td>
                              {{
                                subItem.ProviderContractNo
                                  ? subItem.ProviderContractNo
                                  : "-"
                              }}
                            </td>
                            <td>{{ subItem.ContractTypeDesc }}</td>
                            <td>{{ subItem.ContractPhaseDesc }}</td>
                            <td>{{ subItem.RoleDesc }}</td>
                            <td>{{ subItem.ProviderTypeCodeDesc }}</td>
                            <td>{{ subItem.ProviderCodeDesc }}</td>
                            <td>{{ subItem.ContractRequestDate }}</td>
                            <td>{{ subItem.LastUpdateDate }}</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                          <tr>
                            <td colspan="12">
                              <no-granted-display
                                :titleName="item.Name"
                                :subitem="subItem"
                              ></no-granted-display>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <v-card-subtitle>
                      {{ item.Name }} Detail (Active, Closed, Close in Advance)
                    </v-card-subtitle>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">No</th>
                            <th class="text-left">CB Contract Code</th>
                            <th class="text-left">Provider Contract Number</th>
                            <th class="text-left">Contract type</th>
                            <th class="text-left">Contract Phase</th>
                            <th class="text-left">Role</th>
                            <th class="text-left">Start Date</th>
                            <th class="text-left">Due Date</th>
                            <th class="text-left">Collaterals Counter</th>
                            <th class="text-left">Total Collateral Value</th>
                            <th class="text-left">Guarantors Counter</th>
                            <th class="text-left">Provider Type</th>
                            <th class="text-left">Provider</th>
                            <th class="text-left">last Update Date</th>
                            <th class="text-left">Link Subject List</th>
                            <th class="text-left">Note</th>
                            <!-- <th colspan="15">COLS</th> -->
                          </tr>
                        </thead>
                        <tbody
                          v-for="(subItem, index) in item.Granted"
                          :key="index"
                        >
                          <tr>
                            <td>{{ index + 1 }}</td>
                            <td>{{ subItem.CBContractCode }}</td>
                            <td>-</td>
                            <td>{{ subItem.ContractTypeCodeDesc }}</td>
                            <td>{{ subItem.ContractPhaseDesc }}</td>
                            <td>{{ subItem.RoleDesc }}</td>
                            <td>{{ subItem.StartDate }}</td>
                            <td>{{ subItem.DueDate }}</td>
                            <td>{{ subItem.CollateralsCounter }}</td>
                            <td>
                              IDR {{ toRupiah(subItem.TotalCollateralValue) }}
                            </td>
                            <td>{{ subItem.GuarantorsCounter }}</td>
                            <td>{{ subItem.ProviderTypeCodeDesc }}</td>
                            <td>{{ subItem.ProviderCodeDesc }}</td>
                            <td>{{ subItem.ReferenceDate }}</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                          <tr>
                            <td colspan="16">
                              <child-table-component
                                :subItem="subItem.listProfile"
                              ></child-table-component>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <v-card
                      v-for="(subItem, index) in item.Granted"
                      :key="index"
                      class="my-3"
                    >
                      <v-card-subtitle class="font-weight-bold">
                        Detail of {{ item.Name }} {{ index + 1 }}:
                        {{ subItem.ContractTypeCodeDesc }} -
                        {{ subItem.ContractPhaseDesc }}
                      </v-card-subtitle>
                      <v-card-text>
                        <v-simple-table dense class="grey lighten-2 mb-2">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Provider Type</th>
                                <th class="text-left">Provider</th>
                                <th class="text-left">CB Contract Code</th>
                                <th class="text-left">Provider Contract No.</th>
                                <th class="text-left">Role</th>
                                <th class="text-left">Last Update Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ subItem.ProviderTypeCodeDesc }}</td>
                                <td>{{ subItem.ProviderCodeDesc }}</td>
                                <td>{{ subItem.CBContractCode }}</td>
                                <td>-</td>
                                <td>{{ subItem.RoleDesc }}</td>
                                <td>{{ subItem.ReferenceDate }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table dense class="mb-2">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Start Date</th>
                                <th class="text-left">Due Date</th>
                                <th class="text-left">Past Due Status</th>
                                <th class="text-left">Contract Status</th>
                                <th class="text-left">Contract Status Date</th>
                                <!-- <th class="text-left">Information</th> -->
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ subItem.StartDate }}</td>
                                <td>{{ subItem.DueDate }}</td>
                                <td>{{ subItem.PastDueStausDesc }}</td>
                                <td>{{ subItem.ContractStatusDesc }}</td>
                                <td>{{ subItem.ContractStatusDate }}</td>
                                <!-- <td>
                                  {{
                                    subItem.Information
                                      ? subItem.Information
                                      : "-"
                                  }}
                                </td> -->
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-card-subtitle> Historical Data </v-card-subtitle>
                        <v-divider :thickness="3" class="blue"></v-divider>
                        <v-simple-table dense class="mb-2">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Reference Date</th>
                                <th class="text-left">Days Past Due</th>
                                <th class="text-left">Over Due</th>
                                <th class="text-left">Bad Credit Cause</th>
                                <th class="text-left">Debit Balance</th>
                                <th class="text-left">
                                  Current Month Realization
                                </th>
                                <th class="text-left">Contract Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  subChildItem, index
                                ) in subItem.listProfileArr"
                                :key="index"
                              >
                                <td>
                                  {{ subChildItem.ReferenceYear }} -
                                  {{
                                    generateMonth(subChildItem.ReferenceMonth)
                                  }}
                                </td>
                                <td>
                                  {{
                                    subChildItem.DaysPastDue
                                      ? subChildItem.DaysPastDue
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    subChildItem.Overdue
                                      ? `IDR ${toRupiah(subChildItem.Overdue)}`
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    subChildItem.BadCreditCauseDesc
                                      ? subChildItem.BadCreditCauseDesc
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    subChildItem.DebitBalance
                                      ? `IDR ${toRupiah(
                                          subChildItem.DebitBalance
                                        )}`
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    subChildItem.CurrentMonthRealization
                                      ? `IDR
                                    ${toRupiah(
                                      subChildItem.CurrentMonthRealization
                                    )}`
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    subChildItem.ContractStatusDesc
                                      ? subChildItem.ContractStatusDesc
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-card-subtitle>
                          Granted {{ item.Name }}
                        </v-card-subtitle>
                        <v-divider :thickness="3" class="blue"></v-divider>
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Caracteristic Credit
                                </p>
                                <p>
                                  {{
                                    subItem.CodeCharacteristicCreditDesc
                                      ? subItem.CodeCharacteristicCreditDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Agrement Credit
                                </p>
                                <p>
                                  {{
                                    subItem.CodeAgreementCreditDesc
                                      ? subItem.CodeAgreementCreditDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Original Agrement Number
                                </p>
                                <p>
                                  {{
                                    subItem.OriginalAgreementNumber
                                      ? subItem.OriginalAgreementNumber
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Original Agrement Date
                                </p>
                                <p>
                                  {{
                                    subItem.OriginalAgreementDate
                                      ? subItem.OriginalAgreementDate
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Final Agreement Number
                                </p>
                                <p>
                                  {{
                                    subItem.FinalAgreementNumber
                                      ? subItem.FinalAgreementNumber
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Final Agrement Date
                                </p>
                                <p>
                                  {{
                                    subItem.FinalAgreementDate
                                      ? subItem.FinalAgreementDate
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Credit Frequency
                                </p>
                                <p>
                                  {{
                                    subItem.FrequencyOfCredit
                                      ? subItem.FrequencyOfCredit
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Credit Start Date
                                </p>
                                <p>
                                  {{
                                    subItem.StartDate ? subItem.StartDate : "-"
                                  }}
                                </p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Debtor Category
                                </p>
                                <p>
                                  {{
                                    subItem.DebtorCategoryCodeDesc
                                      ? subItem.DebtorCategoryCodeDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Usage Type</p>
                                <p>
                                  {{
                                    subItem.UsageTypeCodeDesc
                                      ? subItem.UsageTypeCodeDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Usage Orientation
                                </p>
                                <p>
                                  {{
                                    subItem.UsageOrientationCodeDesc
                                      ? subItem.UsageOrientationCodeDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Economic Sector
                                </p>
                                <p>
                                  {{
                                    subItem.EconomicSectorCodeDesc
                                      ? subItem.EconomicSectorCodeDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">City</p>
                                <p>
                                  {{
                                    subItem.CityCodeDesc
                                      ? subItem.CityCodeDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Project Value</p>
                                <p>
                                  {{
                                    subItem.ProjectValue
                                      ? `IDR ${toRupiah(subItem.ProjectValue)}`
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Type of Interest Rate
                                </p>
                                <p>
                                  {{
                                    subItem.TypeOfInterestRateDesc
                                      ? subItem.TypeOfInterestRateDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Interest Rate</p>
                                <p>
                                  {{
                                    subItem.InterestRate
                                      ? `${subItem.InterestRate}%`
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Financing Program
                                </p>
                                <p>
                                  {{
                                    subItem.FinancigProgramDesc
                                      ? subItem.FinancigProgramDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card-subtitle>
                          {{ item.Name }} Limit/Debit Balance
                        </v-card-subtitle>
                        <v-divider :thickness="3" class="blue"></v-divider>
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Initial Credit Limit
                                </p>
                                <p>
                                  IDR {{ toRupiah(subItem.InitialCreditLimit) }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Credit Limit</p>
                                <p>IDR {{ toRupiah(subItem.CreditLimit) }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Currmet Month Realization
                                </p>
                                <p>
                                  {{
                                    subItem.CurrentMonthRealization == "0"
                                      ? "-"
                                      : subItem.CurrentMonthRealization
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Debit Balance</p>
                                <p>IDR {{ toRupiah(subItem.DebitBalance) }}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Value in Original Currency
                                </p>
                                <p>
                                  {{
                                    subItem.ValueInOriginalCurrency == "0"
                                      ? "-"
                                      : subItem.ValueInOriginalCurrency
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card-subtitle> Overdue </v-card-subtitle>
                        <v-divider :thickness="3" class="blue"></v-divider>
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Principle Overdue Amount
                                </p>
                                <p>
                                  IDR
                                  {{ toRupiah(subItem.PrincipalOverdueAmount) }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Interest Overdue Amount
                                </p>
                                <p>
                                  IDR
                                  {{ toRupiah(subItem.InterestOverdueAmount) }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Days Past Due</p>
                                <p>{{ subItem.DaysPastDue }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Overdue Payments Number
                                </p>
                                <p>{{ subItem.OverduePaymentsNumber }}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Bad Credit Cause
                                </p>
                                <p>
                                  {{
                                    subItem.BadCreditCauseDesc
                                      ? subItem.BadCreditCauseDesc
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Bad Credit Date
                                </p>
                                <p>
                                  {{
                                    subItem.BadCreditDate
                                      ? subItem.BadCreditDate
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Penalty</p>
                                <p>
                                  {{
                                    subItem.Penalty !== "0"
                                      ? "IDR " + toRupiah(subItem.Penalty)
                                      : "-"
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card-subtitle> Restructuring </v-card-subtitle>
                        <v-divider :thickness="3" class="blue"></v-divider>
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Restructuring Plan
                                </p>
                                <p>{{ "-" }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Initial Restructuring Date
                                </p>
                                <p>{{ "-" }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Final Restructuring Date
                                </p>
                                <p>{{ "-" }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Frequency of Restructuring
                                </p>
                                <p>
                                  {{
                                    subItem.FrequencyOfRestructuring == "0"
                                      ? "-"
                                      : subItem.FrequencyOfRestructuring
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card-subtitle>
                          {{ item.Name }} Maximum
                        </v-card-subtitle>
                        <v-divider :thickness="3" class="blue"></v-divider>
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Max Overdue Payments Amount
                                </p>
                                <p>
                                  IDR
                                  {{
                                    toRupiah(subItem.MaxOverduePaymentsAmount)
                                  }}
                                </p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Max Overdue Payments Number
                                </p>
                                <p>{{ subItem.MaxOverduePaymentsNumber }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Max Overdue Payments Number Date
                                </p>
                                <p>{{ subItem.WorstStatusDate }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Max Days Past Due
                                </p>
                                <p>{{ subItem.MaxDaysPastDue }}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Max Days Past Due Date
                                </p>
                                <p>{{ subItem.WorstStatusDate }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">Worst Status</p>
                                <p>{{ subItem.WorstStatusDesc }}</p>
                              </v-col>
                              <v-col md="3">
                                <p class="font-weight-medium">
                                  Max Overdue Payments Number Date
                                </p>
                                <p>{{ subItem.WorstStatusDate }}</p>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <div
                          v-for="(
                            subChildItem, index
                          ) in subItem.GrantedCollaterals"
                          :key="index"
                        >
                          <v-card-subtitle
                            >Detail of Collaterals {{ index + 1 }} :
                            {{
                              subChildItem.CollateralTypeDesc
                            }}</v-card-subtitle
                          >
                          <v-divider :thickness="3" class="blue"></v-divider>
                          <v-card>
                            <v-card-text>
                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Provider Type
                                  </p>
                                  <p>{{ subChildItem.ProviderTypeCodeDesc }}</p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">Provider</p>
                                  <p>
                                    {{ subChildItem.ProviderCodeDesc }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Last Update Date
                                  </p>
                                  <p>
                                    {{ subChildItem.ReferenceDate }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-subtitle
                              >Granted Collateral</v-card-subtitle
                            >
                            <v-divider :thickness="3" class="blue"></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Collateral Number
                                  </p>
                                  <p>{{ subChildItem.CollateralNumber }}</p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Collateral Status
                                  </p>
                                  <p>
                                    {{ subChildItem.CollateralStatusDesc }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">Rating</p>
                                  <p>
                                    {{
                                      subChildItem.CollateralRating
                                        ? subChildItem.CollateralRating + "%"
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Rating Institution
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.RatingInstitutionDesc
                                        ? subChildItem.RatingInstitutionDesc
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">Bind Type</p>
                                  <p>{{ subChildItem.BindTypeDesc }}</p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">Bind Date</p>
                                  <p>
                                    {{ subChildItem.BindDate }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Collateral Owner Name
                                  </p>
                                  <p>
                                    {{ subChildItem.CollateralOwnerName }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Proof of Ownership
                                  </p>
                                  <p>
                                    {{ subChildItem.ProofOfOwnership }}
                                  </p>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Common Collateral Status
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CommonCollateralStatusDesc
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Common Collateral Percentage
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CommonCollateralPercentage ==
                                      "0"
                                        ? "-"
                                        : subChildItem.CommonCollateralPercentage
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Joint Account Credit Status
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.JointAccountCreditStatusDesc
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">Insured</p>
                                  <p>
                                    {{ subChildItem.InsuredDesc }}
                                  </p>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">Information</p>
                                  <p>
                                    {{
                                      subChildItem.Information
                                        ? subChildItem.Information
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-subtitle>Collateral Value</v-card-subtitle>
                            <v-divider :thickness="3" class="blue"></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Collateral Value NJOP
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CollateralValueNJOP
                                        ? "IDR " +
                                          toRupiah(
                                            subChildItem.CollateralValueNJOP
                                          )
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Collateral Value Reporter
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CollateralValueReporter
                                        ? "IDR " +
                                          toRupiah(
                                            subChildItem.CollateralValueReporter
                                          )
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Assessment Date Reporter
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CollateralAssessmentDateReporter
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Collateral Value Indipendent Assersors
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CollateralValueIndependentAssessors ==
                                      "0"
                                        ? "-"
                                        : subChildItem.CollateralValueIndependentAssessors
                                    }}
                                  </p>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Independent Assessors Name
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.IndependentAssessorsName
                                        ? subChildItem.IndependentAssessorsName
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Assessment Date Indipendent Assersors
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.CollateralAssessmentDateAssessors
                                        ? subChildItem.CollateralAssessmentDateAssessors
                                        : "-"
                                    }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-subtitle
                              >Collateral Address</v-card-subtitle
                            >
                            <v-divider :thickness="3" class="blue"></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col md="12">
                                  <p class="font-weight-medium">Address</p>
                                  <p>
                                    {{ subChildItem.Address }},
                                    {{ subChildItem.CityDesc }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>

                        <div
                          v-for="(
                            subChildItem, index
                          ) in subItem.GuarantorsData"
                          :key="index"
                        >
                          <v-card-subtitle
                            >Detail of Guarantor {{ index + 1 }} :
                            {{
                              subChildItem.GuarantorTypeDesc
                            }}</v-card-subtitle
                          >
                          <v-divider :thickness="3" class="blue"></v-divider>
                          <v-card>
                            <v-card-text>
                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Provider Type
                                  </p>
                                  <p>{{ subChildItem.ProviderTypeCodeDesc }}</p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">Provider</p>
                                  <p>
                                    {{ subChildItem.ProviderCodeDesc }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Last Update Date
                                  </p>
                                  <p>
                                    {{ subChildItem.ReferenceDate }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-subtitle>Granted Guarantor</v-card-subtitle>
                            <v-divider :thickness="3" class="blue"></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Guarantor Name as ID
                                  </p>
                                  <p>{{ subChildItem.GuarantorNameAsID }}</p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Guarantor Full Name
                                  </p>
                                  <p>
                                    {{ subChildItem.GuarantorFullName }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Percentage Guaranteed
                                  </p>
                                  <p>
                                    {{
                                      subChildItem.PercentageGuaranteed == "0"
                                        ? "-"
                                        : subChildItem.PercentageGuaranteed +
                                          "%"
                                    }}
                                  </p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">Information</p>
                                  <p>
                                    {{ "-" }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-subtitle
                              >Guarantor Identity</v-card-subtitle
                            >
                            <v-divider :thickness="3" class="blue"></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Identity Type
                                  </p>
                                  <p>{{ subChildItem.IdentityTypeDesc }}</p>
                                </v-col>
                                <v-col md="3">
                                  <p class="font-weight-medium">
                                    Identity Number
                                  </p>
                                  <p>
                                    {{ subChildItem.IdentityNumber }}
                                  </p>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-subtitle
                              >Collateral Address</v-card-subtitle
                            >
                            <v-divider :thickness="3" class="blue"></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col md="12">
                                  <p class="font-weight-medium">Address</p>
                                  <p>{{ subChildItem.Address }}</p>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              ACCOUNT RECEIVABLE / PAYABLES
            </v-card-title>
            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                General Business Company
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-subtitle> Open Transactions </v-card-subtitle>
              <v-divider :thickness="3"></v-divider>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default v-if="resultsDataXml !== null">
                    <thead>
                      <tr>
                        <th class="text-left">Provider</th>
                        <th class="text-left">TransactionType</th>
                        <th class="text-left">TransactionAmount</th>
                        <th class="text-left">Document Date</th>
                        <th class="text-left">Expiry/Due Date</th>
                        <th class="text-left">Close Date</th>
                        <th class="text-left">Dispute Flag</th>
                        <th class="text-left">Dispute Date</th>
                        <th class="text-left">Last Reference Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in resultsDataXml
                          .accountReceivablesData.AccountReceivables"
                        :key="index"
                      >
                        <td>
                          {{
                            item.ProviderCodeDesc ? item.ProviderCodeDesc : ""
                          }}
                        </td>
                        <td>
                          {{
                            item.TransactionTypeDesc
                              ? item.TransactionTypeDesc
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            item.TransactionAmount
                              ? "IDR " + toRupiah(item.TransactionAmount)
                              : ""
                          }}
                        </td>
                        <td>
                          {{ item.DocumentDate ? item.DocumentDate : "" }}
                        </td>
                        <td>{{ item.ExpiryDate ? item.ExpiryDate : "" }}</td>
                        <td>{{ item.ClosingDate ? item.ClosingDate : "-" }}</td>
                        <td>
                          {{ item.DisputeFlagDesc ? item.DisputeFlagDesc : "" }}
                        </td>
                        <td>{{ item.DisputeDate ? item.DisputeDate : "-" }}</td>
                        <td>
                          {{ item.ReferenceDate ? item.ReferenceDate : "" }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              ADDITIONAL INFORMATION
            </v-card-title>
            <v-card class="mb-6">
              <v-expansion-panels>
                <v-expansion-panel v-for="(item, i) in 1" :key="i">
                  <v-expansion-panel-header>
                    Debt Mediations
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-col
                      cols="12"
                      v-for="(item, index) in resultsDataXml !== null
                        ? resultsDataXml.subjectAdditionalInfoData
                            .SubjectAdditionalInfo
                        : []"
                      :key="index"
                    >
                      <v-simple-table dark>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">
                                Additional Information No
                              </th>
                              <th class="text-left">Provider Type</th>
                              <th class="text-left">Provider</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ item.AdditionalInformationNo }}</td>
                              <td>{{ item.ProviderTypeCodeDesc }}</td>
                              <td>{{ item.ProviderCodeDesc }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">No</th>
                              <th class="text-left">Information Type</th>
                              <th class="text-left">Details</th>
                              <th class="text-left">Status</th>
                              <th class="text-left">Status Date</th>
                              <th class="text-left">Last Reference Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                subItem, index
                              ) in item.AdditionalInfoDetails"
                              :key="index"
                            >
                              <td>{{ index + 1 }}</td>
                              <td>
                                {{ subItem.AdditionalInformationTypeDesc }}
                              </td>
                              <td>{{ subItem.AdditionalInformationValue }}</td>
                              <td>{{ subItem.StatusDesc }}</td>
                              <td>{{ subItem.StatusDate }}</td>
                              <td>{{ subItem.ReferenceDate }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              NEGATIVE EVENTS
            </v-card-title>
            <v-card class="mb-6">
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">No.</th>
                        <th class="text-left">Event</th>
                        <th class="text-left">Event Details</th>
                        <th class="text-left">Event Date</th>
                        <th class="text-left">Event Expiry Date</th>
                        <th class="text-left">Provider Type</th>
                        <th class="text-left">Provider</th>
                        <th class="text-left">Last Reference Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          item, index
                        ) in resultsDataXml.negativeEventsData"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.EventCodeDesc }}</td>
                        <td>{{ item.EventDetail }}</td>
                        <td>{{ item.EventDate }}</td>
                        <td>{{ item.EventExpiryDate }}</td>
                        <td>{{ item.ProviderTypeCodeDesc }}</td>
                        <td>{{ item.ProviderCodeDesc }}</td>
                        <td>{{ item.ReferenceDate }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>

            <v-card-title class="pa-5 text-h5 d-block text-center">
              FOOTPRINT
            </v-card-title>
            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                Number of Enquiries in the last months
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">1 Month</th>
                        <th class="text-left">3 Months</th>
                        <th class="text-left">6 Months</th>
                        <th class="text-left">12 Months</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{
                            resultsDataXml !== null
                              ? resultsDataXml.footPrintsData.Count1Month
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            resultsDataXml !== null
                              ? resultsDataXml.footPrintsData.Count3Months
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            resultsDataXml !== null
                              ? resultsDataXml.footPrintsData.Count6Months
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            resultsDataXml !== null
                              ? resultsDataXml.footPrintsData.Count12Months
                              : "-"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>

            <v-card class="mb-6">
              <v-card-subtitle class="mb-3 text-h6">
                Last 15 Enquiries
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Enquiry Date</th>
                        <th class="text-left">Purpose</th>
                        <th class="text-left">Institute</th>
                        <th class="text-left">Enquiry Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in resultsDataXml !== null
                          ? resultsDataXml.footPrintsData.FootPrint
                          : []"
                        :key="index"
                      >
                        <td>{{ item.EnquiryDate ? item.EnquiryDate : "" }}</td>
                        <td>
                          {{ item.PurposeCodeDesc ? item.PurposeCodeDesc : "" }}
                        </td>
                        <td>
                          {{ item.InstituteDesc ? item.InstituteDesc : "" }}
                        </td>
                        <td>
                          {{ item.EnquiryTypeDesc ? item.EnquiryTypeDesc : "" }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end jika match -->
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
  
<script>
import regionDomain from "@/store/services/finance/click/items/region-domain.js";
import economicSector from "@/store/services/finance/click/items/economic-sector.js";
import facilityType from "@/store/services/finance/click/items/facility-type.js";
import {
  F01,
  F02,
  F03,
  F04,
  F05,
  F06,
} from "@/store/services/finance/click/items/contract-type-category";
import ChildTableComponent from "./components/ChildTableComponent.vue";
import companyCategoryItems from "@/store/services/finance/click/items/company-category.js";
import legalFormItems from "@/store/services/finance/click/items/legal-form-items.js";
import NoGrantedDisplay from "./components/NoGrantedDisplay.vue";
import Swal from "sweetalert2";
export default {
  name: "NewAppEnqB2b",

  components: {
    // StepProgress,
    ChildTableComponent,
    NoGrantedDisplay,
  },

  props: ["setTabDefault"],

  data: () => ({
    currentStep: 0,
    dialog: false,
    textDialog: null,

    // for Rules Individual Data
    purposeOfEnqRules: [
      (v) => {
        // console.log(v);
        if (!!v && v.length > 0) return true;
        return "Purpose Of Enq not required!";
      },
    ],
    idMessageRules: [
      (v) => {
        // console.log(v);
        if (!!v && v.length > 0) return true;
        return "ID Message not required!";
      },
    ],
    tradeNameRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Trade Name not required!";
      },
    ],
    addressRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Address not required!";
      },
    ],
    subDistrictRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Sub District not required!";
      },
    ],
    districtRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "District not required!";
      },
    ],
    cityRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "City not required!";
      },
    ],
    postalCodeRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Postal Code not required!";
      },
      (v) => {
        if (!!v && v.length < 6) return true;
        return "Postal Code max 5 caracter!";
      },
    ],
    countryRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Country not required!";
      },
    ],
    businessIdentityNumberRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Identity Number not required!";
      },
    ],
    cellphoneNumberRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        return "Cell Phone Number not required!";
      },
    ],

    // Rules App data
    contractCategoryRules: [],
    roleInApplicationRules: [],
    contractTypeRules: [],
    applicationAmountRules: [],
    cbContractCodeRules: [],
    providerApplicationNoRules: [],

    // for Field input
    purposeOfEnq: null,
    itemsPurposeOfEnq: [
      {
        titleSelect:
          " Support Non Financing Institution operational activities related to the process of identifying customer integrity in terms of credit risk ",
        valSelect: "20",
      },
      {
        titleSelect:
          "Implementation of onboarding process selection for employee, partners, agents traders, and/or Non Financing Institution vendors",
        valSelect: "21",
      },
      { titleSelect: "Compliance with laws and regulations", valSelect: "22" },
    ],
    idMessage: "",
    tradeName: null,
    itemsCompanyCategory: companyCategoryItems,
    companycCategory: null,
    itemsLegalForm: legalFormItems,
    legalForm: null,
    goPublic: null,
    itemsGoPublic: [
      { titleSelect: "Yes", valSelect: "Y" },
      { titleSelect: "No", valSelect: "T" },
    ],
    rating: null,
    itemsratingIntitution: [
      { titleSelect: "MOODY'S", valSelect: "MIS" },
      { titleSelect: "STANDARD AND POOR'S", valSelect: "SNP" },
      { titleSelect: "FITCH RATING", valSelect: "FIN" },
      { titleSelect: "PEFINDO", valSelect: "PEF" },
      { titleSelect: "FITCH INDONESIA", valSelect: "FID" },
    ],
    ratingIntitution: null,
    ratingDate: null,
    placeOfEstablishment: null,
    deedNumberOfEstablishment: null,
    deedDateOfEstablishment: null,
    recentlyAmendmentDeedNumber: null,
    dateOfFinalAmendmentDeed: null,
    address: null,
    subDistrict: null,
    district: null,
    city: null,
    itemsCity: regionDomain, // data list di import dari folder service
    postalCode: null,
    country: null,
    itemsCountry: [{ titleSelect: "INDONESIA", valSelect: "ID" }],
    businessIdentityNumber: null,
    phoneNumber: null,
    cellphoneNumber: null,
    emailAddress: null,
    economicSector: null,
    itemsEconomicSector: economicSector, // data di import dari folder service
    statusApp: "A",
    roleInApplication: null,
    itemsRoleInApplication: [
      { titleSelect: "Borrower", valSelect: "B" },
      { titleSelect: "Co-Borrower", valSelect: "C" },
    ],
    contractCategoryCode: null,
    itemsContractCategoryCode: facilityType,
    contractType: null,
    itemsContractType: [],
    accountNumber: null,
    dueDate: null,
    applicationAmount: null,
    currency: "IDR",
    currencyReadOnly: "Indonesia Rupiah",
    originalAgreementNumber: null,
    originalAgreementDate: null,
    cbContractCode: null,
    providerContractNo: null,
    providerApplicationNo: null,

    progressBtnNext: false,

    // Object for results Data
    resultsDataXml: null,

    // panel componen
    panelContractDetails: [],
    panelShareHolderDetails: [],
  }),

  created() {
    // console.log(this.itemsPurposeOfEnq);
    this.itemsCity = regionDomain;

    // Mendapatkan komponen tahun, bulan, dan tanggal
    let currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    let generateDate = Date.now();
    this.idMessage = currentDate + "_NAEC" + generateDate;
  },

  methods: {
    nextPageForm() {
      // console.log(this.$refs.form.validate());

      // this.progressBtnNext = true;
      if (this.$refs.form.validate()) {
        this.currentStep = 1;
        this.progressBtnNext = false;

        if (this.currentStep == 1) {
          this.roleInApplicationRules = [
            (v) => {
              if (!!v && v.length > 0) return true;
              return "Role In App Number not required!";
            },
          ];
          this.contractCategoryRules = [
            (v) => {
              if (!!v && v.length > 0) return true;
              return "Contract Category not required!";
            },
          ];
          this.contractTypeRules = [
            (v) => {
              if (!!v && v.length > 0) return true;
              return "Contract Type Number not required!";
            },
          ];
          this.applicationAmountRules = [
            (v) => {
              if (!!v && v.length > 0) return true;
              return "App Amount Number not required!";
            },
          ];
        }
      }
    },

    backPageForm() {
      this.currentStep = 0;
      this.roleInApplicationRules = [];
      this.contractTypeRules = [];
      this.applicationAmountRules = [];
    },

    async formSubmit() {
      // console.log(this.$data);

      if (this.$refs.form.validate()) {
        const data = {
          purposeOfEnq: this.purposeOfEnq,
          idMessage: this.idMessage,
          tradeName: this.tradeName,
          companycCategory: this.companycCategory,
          legalForm: this.legalForm,
          goPublic: this.goPublic,
          rating: this.rating,
          ratingIntitution: this.ratingIntitution,
          ratingDate: this.ratingDate,
          placeOfEstablishment: this.placeOfEstablishment,
          deedNumberOfEstablishment: this.deedNumberOfEstablishment,
          deedDateOfEstablishment: this.deedDateOfEstablishment,
          recentlyAmendmentDeedNumber: this.recentlyAmendmentDeedNumber,
          dateOfFinalAmendmentDeed: this.dateOfFinalAmendmentDeed,
          address: this.address,
          subDistrict: this.subDistrict,
          district: this.district,
          city: this.city,
          postalCode: this.postalCode,
          country: this.country,
          businessIdentityNumber: this.businessIdentityNumber,
          phoneNumber: this.phoneNumber,
          cellphoneNumber: this.cellphoneNumber,
          emailAddress: this.emailAddress,
          economicSector: this.economicSector,
          statusApp: this.statusApp,
          roleInApplication: this.roleInApplication,
          contractCategoryCode: this.contractCategoryCode,
          contractType: this.contractType,
          accountNumber: this.accountNumber,
          dueDate: this.dueDate,
          applicationAmount: this.applicationAmount,
          currency: this.currency,
          originalAgreementNumber: this.originalAgreementNumber,
          originalAgreementDate: this.originalAgreementDate,
          cbContractCode: this.cbContractCode,
          providerContractNo: this.providerContractNo,
          providerApplicationNo: this.providerApplicationNo,
        };

        console.log("DATA YANG AKAN DIKIRIM", data);

        await this.$store.dispatch("finance_click/postNewApplicationB2b", data);
        this.resultsDataXml = await this.$store.getters["finance_click/click"];

        console.log("HASIL DARI BE", this.resultsDataXml);

        if (this.resultsDataXml.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.resultsDataXml.messageErr,
          });
        } else {
          this.dialog = true;
          this.$refs.form.reset();
        }
      }
    },

    closeModalBox() {
      this.dialog = false;
      this.currentStep = 0;
      this.setTabDefault();
      // this.$router.push('/');
    },

    onSelectContractCategory(role) {
      this.contractCategoryCode = null;
      this.contractType = null;
      this.itemsContractType = [];
      if (role == "B") {
        this.itemsContractCategoryCode = facilityType;
      } else {
        this.itemsContractCategoryCode = [facilityType[1]];
      }
    },

    onSelectContractType(val) {
      if (val == "F01") {
        this.itemsContractType = F01;
      } else if (val == "F02") {
        this.itemsContractType = F02;
      } else if (val == "F03") {
        this.itemsContractType = F03;
      } else if (val == "F04") {
        this.itemsContractType = F04;
      } else if (val == "F05") {
        this.itemsContractType = F05;
      } else if (val == "F06") {
        this.itemsContractType = F06;
      }
    },

    selectStatusApp() {
      this.roleInApplication = null;
      // console.log(this.statusApp);
      if (this.statusApp !== "C") {
        this.itemsRoleInApplication = [
          { titleSelect: "Borrower", valSelect: "B" },
          { titleSelect: "Co-Borrower", valSelect: "C" },
        ];
      } else {
        this.itemsRoleInApplication = [
          { titleSelect: "Partner", valSelect: "P" },
          { titleSelect: "CEO", valSelect: "E" },
          { titleSelect: "Shareholder", valSelect: "S" },
          { titleSelect: "CFO", valSelect: "F" },
          { titleSelect: "Director", valSelect: "D" },
          { titleSelect: "Boardmember", valSelect: "M" },
        ];
      }

      if (this.statusApp !== "A") {
        this.cbContractCodeRules = [
          (v) => {
            if (!!v && v.length > 0) return true;
            return "CBContract Code not required!";
          },
        ];

        this.providerApplicationNoRules = [
          (v) => {
            if (!!v && v.length > 0) return true;
            return "Provider Application No not required!";
          },
        ];
      } else {
        this.cbContractCode = null;
        this.providerContractNo = null;
        this.providerApplicationNo = null;
        this.cbContractCodeRules = [];
        this.providerApplicationNoRules = [];
      }
    },

    toRupiah(rupiah) {
      var formattedNumber = parseFloat(rupiah).toLocaleString("en");
      return formattedNumber;
    },

    generateMonth(number) {
      if (number == 1) {
        return "JAN";
      } else if (number == 2) {
        return "FEB";
      } else if (number == 3) {
        return "MAR";
      } else if (number == 4) {
        return "APR";
      } else if (number == 5) {
        return "MEI";
      } else if (number == 6) {
        return "JUN";
      } else if (number == 7) {
        return "JUL";
      } else if (number == 8) {
        return "AUG";
      } else if (number == 9) {
        return "SEP";
      } else if (number == 10) {
        return "OCT";
      } else if (number == 11) {
        return "NOV";
      } else if (number == 12) {
        return "DES";
      }
    },

    inputToRupiah() {
      const parsed = this.applicationAmount.replace(/[.,\s]/g, "");
      const formatted = new Intl.NumberFormat("id-ID").format(parsed);
      this.applicationAmount = formatted;
    },
  },
};
</script>